import React, { useState } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { login } from './store/authThunk';
import { LANGUAGE, localVariables } from '../../utils/constants';
import { routesPath } from '../../utils/routesPath';
import { useSelector } from 'react-redux';
import { Button, Dropdown, notification, Select, Space } from 'antd';
import { getProfile } from '../Users/store/profileThunk';
import { saveProfileData } from '../Users/store/profileSlice';
import { useTranslation } from 'react-i18next';

const LoginComponent = ({ ...props }) => {
    const { i18n, t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authData = useSelector((state) => state.auth);

    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);

    const handleSetCredentials = (e) => setCredentials({ ...credentials, ...e });
    const handleChangeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };
    const handleLogin = async () => {
        try {
            const resultAction = await dispatch(login({ credentials, t }));
            if (login.fulfilled.match(resultAction)) {
                const user = resultAction?.payload?.data?.user;
                if (user?.roles[0]?.name == 'Admin') {
                    dispatch(saveProfileData(user));
                    loginSuccess();
                } else {
                    const profileResultAction = await dispatch(getProfile(user));
                    if (getProfile.fulfilled.match(profileResultAction)) {
                        loginSuccess();
                    } else notification.error({ message: t('Login_GetUserProfileError') });
                }
            }
        } catch (error) {
            loginError(error);
        }
    };

    const loginSuccess = () => {
        const rememberPath = localStorage.getItem(localVariables.REMEMBER_PATH);
        if (rememberPath) {
            navigate(rememberPath);
            localStorage.removeItem(localVariables.REMEMBER_PATH);
            return;
        }
        navigate(`../${routesPath.COMMON.HOME}`);
    };

    const loginError = (error) => {
        notification.error({ message: error.message || t('Login_Fail') });
        console.error(error);
    };

    return (
        <div className="auth option2">
            <div className="auth_left">
                <div className="card">
                    <div className="card-body">
                        <div className="text-center">
                            <Link
                                to="/"
                                className="flex justify-center items-center max-h-[140px] overflow-hidden">
                                <img
                                    className="rounded-lg w-2/3"
                                    src="/assets/images/logo.png"
                                    alt="logo"
                                />
                            </Link>
                            <div className="card-title mt-3">{t('Login_LoginToYourAccount')}</div>
                        </div>

                        <div className="form-group">
                            <input
                                type="email"
                                className="form-control"
                                placeholder={t('Login_EnterEmail')}
                                onChange={(e) => handleSetCredentials({ email: e.target.value })}
                            />
                        </div>

                        <div className="form-group relative">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className="form-control pr-10"
                                placeholder={t('Login_Password')}
                                onChange={(e) => handleSetCredentials({ password: e.target.value })}
                            />
                            {/* Toggle Password Visibility */}
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-gray-700 !outline-none"
                                style={{ top: 0, bottom: 0 }}>
                                {showPassword ? (
                                    <i className="fa fa-eye-slash"></i>
                                ) : (
                                    <i className="fa fa-eye"></i>
                                )}
                            </button>

                            <label className="form-label mt-2">
                                <Link
                                    to="/forgotpassword"
                                    className="float-right small">
                                    {t('Login_ForgotPassword')}
                                </Link>
                            </label>
                        </div>

                        <div className="text-center mt-8">
                            <Button
                                onClick={() => handleLogin()}
                                className="btn btn-primary btn-block hover:shadow-md"
                                loading={authData?.loadingLogin == 'loading'}
                                disabled={authData?.loadingLogin == 'loading'}>
                                {t('Login_SignIn')}
                            </Button>
                            <div className="text-muted mt-4">
                                {t('Login_NoAccount')}{' '}
                                <Link
                                    to="/signup"
                                    className="underline font-bold">
                                    {t('Login_SignUp')}
                                </Link>
                            </div>
                        </div>

                        <div className="flex items-center justify-center mt-2">
                            <Select
                                className="!w-16"
                                value={i18n.language}
                                style={{ width: 120 }}
                                onChange={handleChangeLanguage}
                                options={LANGUAGE.map((ele, idx) => {
                                    return {
                                        label: (
                                            <img
                                                className="w20 mr-2"
                                                src={ele?.icon}
                                            />
                                        ),
                                        value: ele?.key
                                    };
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

LoginComponent.displayName = 'Login';

const Login = (props) => {
    return (
        <ErrorWrapper>
            <LoginComponent
                data-id="Login-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default Login;
